<h2 *ngIf="data.title" mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <div *ngIf="data.message">{{ data.message }}</div>
  <mat-form-field>
    @if (data.label) {
      <mat-label>{{ data.label }}</mat-label>
    }
    <input matInput [(ngModel)]="data.value" [required]="true">
    @if (data.icon) {
      <mat-icon matPrefix>{{ data.icon }}</mat-icon>
    }
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close i18n>Cancel</button>
  <button mat-button [mat-dialog-close]="data.value" [disabled]="!data.value" i18n>OK</button>
</mat-dialog-actions>
